t = require('views/internal/teacup-with-helpers')('popover_confirm_member_delete')

module.exports = ->
  t.p ->
    t.format 'deleting-your-member-account-username-will-be-permanent', { username: t.mustacheVar('username') }
  t.p ->
    t.b ->
      t.format 'you-will-lose-access-to-your-boards-and-organizations'
  t.p ->
    t.format 'would-you-like-us-to-send-an-email-to-email-that-contains-a-link-that-you-can-use-to-delete-your-account', { email: t.mustacheVar('email') }

  t.input '.js-delete-member', { type: 'submit', value: t.l('send-the-email') }
  t.input '.js-cancel-delete', { type: 'submit', value: t.l('never-mind') }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_confirm_member_delete.coffee